export default __webpack_public_path__ + "5727a288740eaac4ef33863a092172a9.ttf";